<template>
  <BbBtn
    :class="{ selected: isSaved, delete: isCollectionAdded }"
    size="large"
    type="icon"
    :icon="icon"
    icon-size="small"
    no-background
    :icon-type="iconType"
    @click="handleCollection"
  />
</template>

<script>
import useCollections from '~/composables/useCollections';
import { computed } from 'vue';
import { COLLECTIONS } from '~/constants/collections';

export default {
  props: {
    document: {
      type: [String, Object],
      default: () => {},
    },
    collectionId: {
      type: String,
      default: COLLECTIONS.favorites,
    },
  },

  setup(props) {
    const { handleCollections, isInCollection } = useCollections();

    const isSaved = computed(() => isInCollection(props.collectionId, props.document.externalId).value);
    const isCollectionAdded = computed(
      () =>
        props.collectionId !== COLLECTIONS.favorites &&
        isInCollection(props.collectionId, props.document.externalId).value,
    );
    const icon = computed(() =>
      props.collectionId === COLLECTIONS.favorites ? 'heart' : isSaved.value ? 'delete' : 'plus-small',
    );
    const iconType = computed(() =>
      isSaved.value && props.collectionId === COLLECTIONS.favorites ? 'filled' : 'outlined',
    );

    const handleCollection = () => handleCollections(props.document, props.collectionId);

    return {
      handleCollection,
      icon,
      iconType,
      isSaved,
      isCollectionAdded,
    };
  },
};
</script>

<style scoped lang="scss">
.selected {
  border: 1px solid $bb-primary-3 !important;
  background-color: $bb-interface-8 !important;

  :deep(.v-btn__content) {
    color: $bb-primary-3;
  }
}

button:hover {
  :deep(.v-btn__content) {
    color: $bb-neutral-1;
  }
}

.delete {
  border: 1px solid $bb-interface-5 !important;
  background-color: $bb-neutral-0 !important;

  :deep(.v-btn__content) {
    color: $bb-interface-5;
  }
}
</style>
